import React, { memo } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Typo, Wishlist, ReviewStar } from 'tmt-ui-kit';
// import { scroller } from 'react-scroll';

import ShareButton from './ShareButton';
import Link from '~/components/Link/Link';
import scrollTo from '~/utils/scroller';

// import ReviewStar from '~/components/Reviews/ReviewStar';

// import { getRatingPoint } from '~/utils/helpers';

// import PriceBlock from './PriceBlock';
// import Typo from '../Typo';
// import Wishlist from '../Wishlist';
// import ShareButton from '../Share';
// import withResetStyle from '../../utils/withResetStyle';

const PlaceWithPadding = styled(Typo.HeaderOne).attrs({
  as: 'p'
})`
  color: ${props => props.theme.blue} !important;
  margin: 0;
  font-size: 16px !important;
  @media(max-width: 600px) {
    margin-right: 8px;
  }
`;

const TitleContainer = styled.div`
  padding-bottom: 16px;
  @media(max-width: 600px) {
    padding: 8px 0 16px;
  }
`;

const PlaceContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 8px 0;
  >div {
    display: flex;
    align-items: center;
    @media(max-width: 600px) {
      flex-direction: column;
      align-items: flex-start;
    }
  }
  @media (max-width: 600px) {
    align-items: flex-start;
    height: fit-content;
  }
`;

const StartFromLocation = styled(Typo.Paragraph)`
  padding-left: 6px !important;
  margin: 0;
  @media (max-width: 600px) {
    padding-left: 0px !important;
    >span {
      display: none;
    }
  }
`;

const ReviewsCount = styled(Typo.Paragraph)`
  margin: 0;
  ${props => props.isMasterTrip && `
    font-weight: 500 !important;
    color: ${props.theme.white} !important;
  `}
  ${props => !props.isMasterTrip && `
    padding-left: 13px !important;
  `}
`;

const RatingContainer = styled.div`
  display: flex;
  align-items: center;
  padding-top: 8px;
  @media (min-width: 1200px) {
    padding-top: 1px;
  }
  @media (max-width: 540px) {
    padding-top: 8px;
  }
`;

const ReviewStarWithPadding = styled(ReviewStar)`
  padding-top: 1px;
`;

const Spanner = styled.span`
  display: inline-block;
  font-size: 14px !important;
  font-weight: 300 !important;
  font-family: ${props => props.theme.font};
  line-height: 1.57 !important;
  color: ${props => props.theme.darkBlue} !important;
  @media (max-width: 1200px) {
    display: none;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  width: 220px;
  justify-content: space-between;
`;

const ReviewCountContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  ${props => props.isMasterTrip && `
    background: ${props.theme.greenLighter};
    padding: 4px 18px 4px 8px;
    border-radius: 6px;
  `}
`;

const Arrow = styled.div`
  z-index: 2;
  position: relative;
  left: 4px;
  top: 0px;
  width: 6px;
  height: 6px;
  border-width: 1px;
  border-style: solid;
  border-color: transparent  ${props => (props.isMasterTrip ? '#ffffff #ffffff' : 'rgba(66, 94, 108, 0.7) rgba(66, 94, 108, 0.7)')} transparent;
  transform:rotate(315deg);
`;

const TripName = styled(Typo.HeaderOne)`
  width: 552px;
  margin: 0;
`;

const TripNameContainer = styled.div`
  display: flex;
  padding-top: 8px;
  align-items: center;
`;

const Image = styled.img`
  width: 88px;
  margin-right: 10px;
`;

const PlaceDetailContainer = styled.div`
  justify-content: flex-start;
`;

const scrollToReview = () => {
  scrollTo('review', {
    offset: -100,
    duration: 500,
    smooth: true,
  });
};

const Title = (props, context) => {
  const {
    trip,
    isWishlisted,
    onClickShare,
    onClickWishlist,
  } = props;
  const { staticImagePath } = context;

  return (
    <TitleContainer>
      <TripNameContainer>
        <TripName>{trip.name}</TripName>
        <Spanner>
          <ButtonContainer>
            <ShareButton onClick={onClickShare} dark showText withHoverEffect />
            <Wishlist onClick={onClickWishlist} wished={isWishlisted} dark showText />
          </ButtonContainer>
        </Spanner>
      </TripNameContainer>
      <PlaceContainer>
        {trip.is_master_trip && !trip.is_localtable_trip && (
          <Image
            alt="TakeMeTour Signature Trip"
            src={staticImagePath('/trips/signature-sign.png')}
            srcSet={`${staticImagePath('/trips/signature-sign@2x.png')} 2x`}
          />
        )}
        {trip.is_localtable_trip && !trip.is_master_trip && (
          <Image
            alt="LocalTable"
            src={staticImagePath('/trips/LocalTable-logo.png')}
            srcSet={`${staticImagePath('/trips/LocalTable-logo@2x.png')} 2x`}
          />
        )}
        <PlaceDetailContainer>
          {trip && trip.destination_location && (
            <Link to={`/to/${trip.destination_location}`}>
              <PlaceWithPadding>{trip.destination_location}</PlaceWithPadding>
            </Link>
          )}
          {trip.product_type === 'trip'
            && trip.meeting_point_locations
            && trip.meeting_point_locations.length > 0
            && trip.meeting_point_locations.join() !== trip.destination_location
            && (
              <StartFromLocation>Pickup from {trip.meeting_point_locations.join(' or ')}</StartFromLocation>
            )}
        </PlaceDetailContainer>
      </PlaceContainer>
      {!trip.is_hide_review && trip.review_count > 0 && (
        <RatingContainer>
          <ReviewStarWithPadding score={trip.rating} hideScoreText />
          <ReviewCountContainer
            onClick={scrollToReview}
            isMasterTrip={trip.is_master_trip}
          >
            <ReviewsCount isMasterTrip={trip.is_master_trip}>{trip.review_count + (trip.travelers_without_review || 0)} reviews</ReviewsCount>
            <Arrow isMasterTrip={trip.is_master_trip} />
          </ReviewCountContainer>
        </RatingContainer>
      )}
    </TitleContainer>
  );
};

Title.contextTypes = {
  staticImagePath: PropTypes.func
};

Title.propTypes = {
  trip: PropTypes.object,
  isWishlisted: PropTypes.bool,
  onClickShare: PropTypes.func,
  onClickWishlist: PropTypes.func,
};

export default memo(
  Title,
  (prevProps, nextProps) => {
    if (prevProps.trip._id !== nextProps.trip._id) {
      return false;
    }
    if (prevProps.isWishlisted !== nextProps.isWishlisted) {
      return false;
    }
    return true;
  }
);
